/**
 * Картинки по прямой ссылке: сервер кладёт URL в Photos.full_url и не скачивает файл.
 * В multipart поле photo_urls — JSON-массив строк. Файлы и ссылки считаются вместе.
 */

export function isPhotoUrl(value) {
  const raw = String(value || '').trim();
  if (!raw) return false;
  try {
    const url = new URL(raw);
    return url.protocol === 'http:' || url.protocol === 'https:';
  } catch (e) {
    return false;
  }
}

export function normalizePhotoUrls(list) {
  const seen = new Set();
  const result = [];
  const source = Array.isArray(list) ? list : [];

  source.forEach((item) => {
    const value = String(item || '').trim();
    if (!isPhotoUrl(value) || seen.has(value)) return;
    seen.add(value);
    result.push(value);
  });

  return result;
}

/** Смешанный список карусели: файлы { file } и ссылки { url } или строки. */
export function splitCarouselPhotos(photos = []) {
  const files = [];
  const urls = [];

  (photos || []).forEach((photo) => {
    if (typeof photo === 'string') {
      urls.push(photo);
      return;
    }
    if (!photo || typeof photo !== 'object') return;
    if (photo.url) {
      urls.push(photo.url);
    } else if (photo.file || photo instanceof Blob) {
      files.push(photo);
    }
  });

  return { files, urls: normalizePhotoUrls(urls) };
}
